import { Typography, TypographyProps } from "@mui/material";

export default function NoPermissionText({
  color,
}: {
  color?: TypographyProps["color"];
}) {
  return (
    <Typography
      sx={{
        color: color,
      }}
    >
      You don{"'"}t have permissions to view this.
    </Typography>
  );
}
